import Form from 'antd/es/form';
import InputNumber from 'antd/es/input-number';
import React from 'react';

interface NumberRangeProps {
  label: string;
  name: string;
  min?: number;
  max?: number;
  step?: number;
  placeholder?: string;
  required?: boolean;
  help?: string;
}

export const NumberRange: React.FC<NumberRangeProps> = ({
  label,
  name,
  min,
  max,
  step = 1,
  placeholder,
  required = false,
  help,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={
        required
          ? [{ required: true, message: `${label} is required` }]
          : undefined
      }
      help={help}
    >
      <InputNumber
        min={min}
        max={max}
        step={step}
        placeholder={placeholder}
        style={{ width: '100%' }}
      />
    </Form.Item>
  );
};
